import { ThemedTitleV2 } from "@refinedev/antd";
import { AIOpsLogo } from "./AIOpsLogo";

export const Title = () => {
  return (
    <ThemedTitleV2
      icon={<AIOpsLogo width={24} height={24} />}
      text="VIA AIOps"
    />
  );
}